module.exports = __webpack_public_path__ + "media/images/early-music-2-9ecbca523abc9e6ae23a78dcdb2f8a79.jpg";